/**
 * Discount price cache only — NEVER reads or writes the shopper cart.
 */
(function() {
  if (window.cmgpSafeCartPreview) return;

  var CACHE_KEY = 'cmgp_variant_discount_v11';
  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var memoryCache = null;

  function loadCache() {
    if (memoryCache) return memoryCache;
    try {
      memoryCache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    } catch (e) {
      memoryCache = {};
    }
    return memoryCache;
  }

  function saveCacheToStorage() {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(memoryCache || {}));
    } catch (e) {}
  }

  window.cmgpSafeCartPreview = {
    CACHE_KEY: CACHE_KEY,

    isActive: function() {
      return false;
    },

    getCached: function(variantId) {
      var store = loadCache();
      var entry = store[String(variantId)];
      if (!entry || !entry.t || Date.now() - entry.t > CACHE_TTL) return undefined;
      if (entry.none) return null;
      if (entry.o && entry.f && entry.o > entry.f) {
        return { onSale: true, original: entry.o, final: entry.f };
      }
      return null;
    },

    setCached: function(variantId, pricing) {
      if (!memoryCache) loadCache();
      if (pricing && pricing.onSale) {
        memoryCache[String(variantId)] = { o: pricing.original, f: pricing.final, t: Date.now() };
      } else {
        memoryCache[String(variantId)] = { none: true, t: Date.now() };
      }
      saveCacheToStorage();
    },

    waitForIdle: function() {
      return Promise.resolve();
    },

    abortAndCleanup: function() {
      return Promise.resolve();
    },

    singlePricing: function() {
      return Promise.resolve(null);
    },

    batchPricing: function() {
      return Promise.resolve({});
    }
  };
})();
